import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const TrackingBox = () => {

    const [trackType, setTrackType] = useState("awb");
    const [awbInput, setAwbInput] = useState("");
    const navigate = useNavigate();

    return (
        <>
{/* Track */}
            <div className="sidebar-card">
                <div className="sidebar-card-header">
                    <i className="fa fa-search-location"></i> Track a Shipment
                </div>
                <div className="sidebar-card-body">
                    <div className="track-label">For multiple tracking, use Enter key</div>

                    <div className="track-radio">
                        <label>
                            <input
                                type="radio"
                                name="ttype"
                                checked={trackType === "awb"}
                                onChange={() => setTrackType("awb")}
                            />{" "}
                            Awb No.
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="ttype"
                                checked={trackType === "ref"}
                                onChange={() => setTrackType("ref")}
                            />{" "}
                            Ref No.
                        </label>
                    </div>

                    <textarea
                        className="track-input"
                        rows="3"
                        placeholder={
                            trackType === "awb"
                                ? "Enter AWB Number..."
                                : "Enter Reference Number..."
                        }
                        value={awbInput}
                        onChange={(e) => setAwbInput(e.target.value)}
                    ></textarea>

                    <button
                        className="track-btn"
                        onClick={() => {
                            const values = awbInput
                                .split("\n")
                                .map(v => v.trim())
                                .filter(v => v !== "");

                            if (values.length === 0) {
                                toast.error(`Please enter ${trackType === "awb" ? "AWB" : "Reference"} Number`);
                                return;
                            }

                            if (trackType === "awb") {
                                navigate(`/tracking?awbNo=${values.join(",")}`);
                            } else {
                                navigate(`/tracking?refNo=${values.join(",")}`);
                            }
                        }}
                    >
                        <i className="fa fa-search"></i> Track Shipment
                    </button>

                </div>
            </div>
        </>
    )
}

export default TrackingBox
